import React from 'react';
import { StyledSvg, iconGenerator } from '../Icon';
const BudgeReadIcon = ({ size, deg }) => (React.createElement(StyledSvg, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", size: size, deg: deg },
    React.createElement("path", { fill: "#5087E6", fillRule: "evenodd", d: "M10 3a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0 2.714a4.286 4.286 0 1 0 0 8.572 4.286 4.286 0 0 0 0-8.572z" })));
export const BudgeRead = iconGenerator(BudgeReadIcon);
//# sourceMappingURL=BudgeRead.js.map